import { useQuery } from "@tanstack/react-query"

import { getCoinsReadyToRedeem } from "./api"
import { QUERY_KEYS } from "../../constants"

export const useCoinsReadyToRedeemQuery = (userId: number) => {
  return useQuery({
    queryKey: [QUERY_KEYS.COINS_READY_TO_REDEEM, userId],
    queryFn: () => getCoinsReadyToRedeem(userId),
    enabled: !!userId,
  })
}
